import '../css/checkout.scss';
import {render} from 'preact';
import $ from '@modules/jquery-import';
import mediaQuery from '@util/media-queries';
import Class from '@core/Class';
import ProductCatalogService from '@services/ProductCatalogService';
import FilteredSearch from '@modules/filter/simpleListFilter';
import Module from '@core/Module';
import Events from '@core/Events';
import Modal from '@plugins/modal';
import PaymentSelection from './containers/Checkout/PaymentSelection';
import {printButton, processOrderDialog} from '@util/HtmlComponents';
import dataLayer from './upi/data-layer';
import {jqueryScrolling, jqueryUpiDialog} from '@modules/lazy-imports';

let processOrderDialogHTML = processOrderDialog();
// let processOrderDialogHTML = '<div>Processing</div>';

var init = function ( form ) {
        // handle custom printing module
        this.disabled = false;

        // add validation to PO field
        $( '[id*="PONumber"]' ).attr( 'maxlength', '50' );

        if ( window.location.pathname.indexOf( 'confirmation' ) !== -1 ) {
            $( 'body' ).removeClass( 'checkoutProcess' );
        }

        // preload loading gifs, posting form blocks additional http requests preventing these from displaying
        var imgs = ['upi_loading_small.gif', 'upi_loading_large.gif'];
        var img = new Image();
        for ( var i = 0; i < imgs.length; i++ ) {
            img.src = upi.paths.ORIGIN_CDN + '/images/' + imgs[i];
        }

        var self = this;
        $( this.proxy( function () {
            // wrap address lists in order to prepend filter form when needed
            this.shipping_address_container
                .find( '.addresses' )
                .wrap( '<div class="addressList"></div>' )
                .show();

            this.update_elements();

            this.bind( 'cart:update', this.proxy( this.update ) );
            this.bind( 'cart:submit', this.proxy( this.submit ) );

            // adding "cancel' class to update buttons prevents validation cart updates
            this.update_buttons.addClass( 'cancel' );

            if ( this.payment_wallet_container[0] ) {
                render( <PaymentSelection
                    onSubmitPayment={( {target} ) => this.trigger( 'cart:submit', target )}
                />, this.payment_wallet_container[0] );
            }

            this.address_lists.hide();

            // lazy load address filters only once per address list
            this.address_lists.each( function ( i, list ) {
                var $list = $( list );

                $list.on( 'addresslist:open addresslist:close', function ( data ) {
                    data.list.parent( '.module' ).scrollToElement();
                } );

                $list.one( 'addresslist:open', function () {
                    if ( $list.find( 'address' ).length > 9 ) {
                        var addressFilter = new FilteredSearch( $list.find( 'ul' ), {
                            label: 'Filter Addresses',
                            hint: 'Anaheim, 90620, or Clementine St',
                            placeholder: 'City, ZIP Code, or Street Name'
                        } );

                        $list.on( 'addresslist:close', function ( e ) {
                            addressFilter.clearResults();
                            addressFilter.blur();
                        } );
                        $list.on( 'addresslist:open', function ( e ) {
                            addressFilter.focus();
                        } );
                    }
                } );
            } );

            var handle_pageshow = self.proxy( function ( e ) {
                // re-enable submit buttons when navigating away from page
                this.trigger( 'checkoutpageshow' );
            } );

            $( window ).on( 'pageshow', handle_pageshow );
        } ) );
    },

    toggle_buttons = function ( label, doDisable ) {
        doDisable = typeof doDisable !== 'undefined' ? doDisable : true;

        this.disabled = doDisable;

        $.each( [this.shipping_buttons,
            this.shipping_address_buttons,
            this.billing_address_buttons,
            this.submit_buttons,
            this.update_buttons], function ( i, item ) {
            item[doDisable ? 'addClass' : 'removeClass']( 'disabled' );
        } );

        if ( label ) {
            label.target.attr( 'value', label.text );
        }
    }, enable_submit = function () {
        this.toggle_buttons( null, false );
    }, handle_card_type_change = function ( e ) {
        // toggle CVV field validation requirements based on current cardType
        const cardType = e.currentTarget.value.toLowerCase(), cvvLength = (cardType === 'amex' ? 4 : 3);

        this.cvv_field
            .attr( 'minlength', cvvLength )
            .attr( 'maxlength', cvvLength );

        $( document ).trigger( 'field:validate-if-needed', this.cvv_field );
    }, handle_address_change = function ( e ) {
        var $button = $( e.currentTarget ), $list = $button.siblings( '.addressList:first' );

        this.toggle_address_list( $list );
    }, toggle_address_list = function ( $list ) {
        var isVisible = $list.is( ':visible' );

        $list[isVisible ? 'slideUp' : 'slideDown']( 200 )
            .siblings( '.button' )
            .text( isVisible ? 'Change' : 'Cancel' );

        $list.trigger( {
            type: 'addresslist:' + (!isVisible ? 'open' : 'close'),
            list: $list
        } );
    }, select_address_item = function ( e ) {
        var $selectedAddress = $( e.currentTarget ),
            $address = $( '#' + $selectedAddress.attr( 'name' ) + 'Address' ),
            $container = $selectedAddress.parents( '.module' );

        $selectedAddress
            .parents( 'li' )
            .find( 'address span' )
            .each( function ( i, field ) {
                var $field = $( field );
                $address.find( '.' + $field.attr( 'class' ) ).text( $field.text() );
            } );

        this.toggle_address_list( $address.next() );
        $container.find( 'a.button' ).text( 'Saving...' ).addClass( 'processing' );
    }, handle_pageshow = function () {
        this.enable_submit();
    }, handle_delete_cart = function ( e ) {
        e.preventDefault();
        $( 'body' ).upiDialog( 'Remove all items from your cart?', {
            No: null,
            Yes: function () {
                window.location = e.target.href;
            }
        } );
    }, handle_remove_lineitem = async function ( e ) {
        const {href} = e.currentTarget;
        const matches = href.match( /items=([\w+-]+)/ );
        const redirect = () => window.location = href;

        if ( matches ) {
            e.preventDefault();
            let id = matches[1];
            const item = await ProductCatalogService.getDetail( id );
            dataLayer.cart.sendItemsRemoved( item );
            redirect();
        }
    }, handle_submit = function ( e ) {
        console.log( 'handle submit' );
        if ( 'keypress' === e.type && e.which !== 13 ) {
            return true;
        }

        var target_button, radioList, isRadioButton;

        if ( 'keypress' === e.type ) {
            // find the closest action button for given input target
            target_button = $( e.target )
                .closest( '.paddedBoxContent, #promoCodeBox' )
                .find( '.secondary' );
        }
        else {
            radioList =
                [].concat( this.shipping_buttons.toArray(),
                    this.shipping_address_buttons.toArray(),
                    this.billing_address_buttons.toArray() );
            isRadioButton = $.inArray( e.target, radioList ) !== -1;
            target_button = isRadioButton ? null : e.target;
        }

        if ( !isRadioButton ) {
            // if not a post by radio button - prevent default to stop double post at checkout in IE
            e.preventDefault();
        }

        // if action was triggered from shipping radio button trigger tracking event
        if ( $.inArray( e.target, this.shipping_buttons ) !== -1 ) {
            dataLayer.checkout.setShippingOption( e.target.value );
        }

        // shipping radio buttons will trigger a cart update
        // if event target is part of update_controls collection then the form should be updated
        // else event target was a submit control
        this.trigger( $.inArray( e.target, this.submit_buttons ) === -1 ? 'cart:update' : 'cart:submit', target_button );
    }, /* toggle order totals and active button to indicate page is being updated to user.
     disable submit buttons to prevent multiple posts. */
    update = function ( e, button ) {
        var form = this.el;

        if ( this.is_disabled() ) {
            return false;
        }

        if ( $.inArray( button, this.submit_buttons ) === -1 ) {
            this.order_totals
                .addClass( 'updating' )
                .find( 'h2' )
                .text( 'Updating Totals' );
        }

        this.toggle_buttons( button ? {
            target: $( button ),
            text: 'Updating'
        } : null );
        // patch: safari halts all execution on form post - need short delay in order to display ui processing indicators
        setTimeout( function () {
            form.submit();
        }, 200 );
    }, submit = function ( e, button ) {
        console.log( 'submit' );
        var form = this.el;
        if ( this.is_disabled() ) {
            return false;
        }

        if ( is_payment( button ) ) {
            show_processing();
        }
        this.toggle_buttons();
        this.el.append( create_post_field( button ) );
        // patch: safari halts all execution on form post - need short delay in order to display ui processing indicators
        setTimeout( () => {
            form.submit();
        }, 200 );
    }, is_disabled = function () {
        return this.disabled;
    }, /* private */
    is_payment = function ( button ) {
        return button && !!$( button ).text().match( 'Complete payment' );
    }, show_processing = function () {
        $( 'body' ).prepend( processOrderDialog() );
    }, hide_processing = function () {
        $( '#upi-dialog' ).remove();
    }, stop_processing = function () {
        hide_processing();
        this.toggle_buttons( null, false );
    }, create_post_field = function ( target ) {
        if ( !target ) {
            throw new TypeError( 'POST cart error: "target" in not defined' );
        }

        var input = document.createElement( 'input' );
        input.type = 'hidden';
        input.name = target.name;
        input.value = target.value;
        return input;
    }, update_print_preview = function () {
        var $preview = this.print_preview,
            rootUrl = $preview.attr( 'src' ).split( '?' )[0],
            query = [],
            $inputs = this.print_inputs;

        $inputs.each( function () {
            query.push( [this.name, encodeURIComponent( this.value.trim() )].join( '=' ) );
        } );

        $preview.attr( 'src', rootUrl + '?' + query.join( '&' ) );
    };

const CartModule = Class.extend( $.extend( {
    events: {
        checkoutpageshow: 'handle_pageshow',
        'click delete_cart_button': 'handle_delete_cart',
        'change shipping_buttons': 'handle_submit', //            'click address_buttons': 'handle_submit',
        'change billing_address_buttons': 'handle_submit',
        'change shipping_address_buttons': 'handle_submit',
        'click update_buttons': 'handle_submit',
        'click submit_buttons': 'handle_submit',
        'click remove_lineitem': 'handle_remove_lineitem',
        'keypress update_fields': 'handle_submit',
        'keyup print_inputs': 'update_print_preview',
        'click change_address_buttons': 'handle_address_change',
        'change address_inputs': 'select_address_item',
        'change card_type_select': 'handle_card_type_change'
    },

    elements: {
        'input[name$="UpdateCart_Button"], input[name$="PromoCode_Button"]': 'update_buttons',
        '.shippingOptions [type="radio"]': 'shipping_buttons', //            '#billingAddressOptions input[type="radio"], #shippingAddressContainer input[type="radio"]': 'address_buttons',
        '#billingAddressOptions input[type="radio"]': 'billing_address_buttons',
        '#shippingAddressContainer input[type="radio"]': 'shipping_address_buttons',
        'input[name^="skuQty"], input[name$="PromoCode_TextBox"]': 'update_fields',
        'input[name*="ContinueCheckout_Button"], input[name*="Submit_Button"]': 'submit_buttons', // 'select[name*="cartType"]': 'card_type_select',
        'select': 'card_type_select',
        'input[name*="cvvcode"]': 'cvv_field',
        '#orderSummaryContainer': 'order_totals',
        '#customPrintingContent input': 'print_inputs',
        '#preview': 'print_preview',
        '#cart .delete-cart': 'delete_cart_button',
        '#cart .lineItem > .remove': 'remove_lineitem',
        '.addressList': 'address_lists',
        '.button[title="Change"]': 'change_address_buttons',
        '#cart .addresses input[type="radio"]': 'address_inputs',
        'input[name="SelectedPaymentMethod"]': 'payment_option_radio',
        '#shippingAddressContainer': 'shipping_address_container',
        '#paymentOptions': 'payment_wallet_container',
        '#customPrintSetup': 'custom_print_container',
        '#doCustomPrint': 'custom_print_checkbox'
    },

    init: init,
    handle_delete_cart: handle_delete_cart,
    handle_remove_lineitem: handle_remove_lineitem,
    handle_submit: handle_submit,
    handle_pageshow: handle_pageshow,
    handle_card_type_change: handle_card_type_change,
    toggle_buttons: toggle_buttons,
    stop_processing: stop_processing,
    toggle_address_list: toggle_address_list,
    enable_submit: enable_submit,
    update: update,
    submit: submit,
    is_disabled: is_disabled,
    update_print_preview: update_print_preview,
    select_address_item: select_address_item,
    handle_address_change: handle_address_change
}, Module, Events ) );

$( document ).ready( async function () {

    await Promise.all( [jqueryUpiDialog(), jqueryScrolling()] );

    $( '.addresses' )
        .on( 'radio:select', function ( e, selection ) {
            if ( window.matchMedia( mediaQuery.max.screenMedium ).matches ) {
                $( selection ).scrollToElement();
            }
        } );

    // add "checkmark" to heading if order submitted successfully
    $( '#orderCompleteMsg h2:contains("submitted successfully")' ).addClass( 'success' );

    // FedEx shipping map
    $( '#shippingOptionsContainer .colorbox' ).on( 'click', function ( e ) {
        e.preventDefault();
        if ( e.target && e.target.href ) {
            Modal.getInstance().open( {
                width: 600,
                content: `
                        <img onload="$( window ).trigger('resize.modal')" width="600" height="467" src="${e.target.href}" alt="FedEx shipping map" />
                `
            } )
        }
    } );

    // add print invoice button to invoice header
    if ( $( '#orderCompleteMsg' ).length > 0 ) {
        $( '#body-content header:first > div' )
            .prepend( `<div class="absolute pin-r pin-t mr-8 hidden md:block">${printButton( 'Print Invoice' )}</div>` );
    }

    // patch: extend length of promofield
    $( '#promoField' ).attr( 'maxlength', 36 );

    // initialize the cart
    $( '#checkoutForm, #paymentForm' ).each( ( i, el ) => new CartModule( el ) );

    // display Holiday Shipping message
    if ( upi.conf.SHOW_HOLIDAY_SHIPPING_NOTICE ) {
        var msg = upi.conf.HOLIDAY_SHIPPING_NOTICE;
        var $msgBar = $( '<div class="paddedBlock notice"><p class="msg"></p></div>' );
        $msgBar.find( '.msg' ).text( msg );
        $msgBar.insertBefore( '.cartFooter' );
    }
} );
